import {ExternalBackend} from "./ExternalBackend";

export class MobiyoWorkflow extends ExternalBackend {

  constructor(params) {
    super("mobiyo", params);
  }
}

